import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux'

import { createUser } from '../actions/user'
import { openSnackbar } from "../actions/snackbar"
import { openPopup } from "../actions/popup"

import UserLogin from './UserLogin';

function UserRegister({createUser, openSnackbar, openPopup}) {
    let [email, setEmail] = useState(null)
    const [username, setUsername] = useState(null)
    const [pass, setPass] = useState(null)
    const [company, setCompany] = useState(null)
    const [inn, setInn] = useState(null)
    const [phone, setPhone] = useState('')
    const [role, setRole] = useState("e249a07138dd45d3f4ba27d90d6c2244d")
    const [isCheckRequests, setCheckRequests] = useState(false)
    const [isCheckComments, setCheckComments] = useState(false)
    const [isAccessLPO, setIsAccessLPO] = useState(false);
    const [isPoliticsAccepted, setIsPoliticsAccepted] = useState(false)

    useEffect(() => {
        // специалист оцифровки
        if (role === "b3940d35edbbb3d8204f1b820a87d8e12") {
            setIsAccessLPO(true);
        }
    }, [role]);

    const sign = <span style={{color: '#fe2c2c'}}>*</span>;
    const isSpecLPO = role === 'b3940d35edbbb3d8204f1b820a87d8e12' ? true : false
    const textError = <p className="auth-label-required">Это обязательное поле</p>
    return (
        <form className="auth-registerForm" onSubmit={register}>
            <label className="auth-label clr-white fs-14">Зарегистрироваться как{sign}:</label>
            <select className='auth-select select--right' value={role} onChange={e => setRole(e.target.value)}>
                <option key={0} value='e249a07138dd45d3f4ba27d90d6c2244d'>Держатель сертификата FSC</option>
                <option key={1} value='b3940d35edbbb3d8204f1b820a87d8e12'>Специалист оцифровки актов ЛПО</option>
                <option key={2} value='eeb43e3d0be1d6e8bb92aa704092f9df1'>Аудитор</option>
                <option key={3} value='f23d9209a63265defaeda6693d6f4b94d'>Наблюдатель</option>
            </select>

            <label className="auth-label clr-white fs-14 mt-8">Придумайте никнейм{sign}:</label>
            <input autoComplete='off' name='username' className={`auth-input big ${username === '' ? 'error' : ''}`}
                   type="text" onChange={(e) => setUsername(e.target.value)} required
                   placeholder="Только латинские буквы"/>
            {username === '' && textError}

            <label className="auth-label clr-white fs-14 mt-8">E-mail{sign}:</label>
            <input autoComplete='off' name='email' className={`auth-input big ${email === '' ? 'error' : ''}`}
                   type="text" onChange={(e) => setEmail(e.target.value)} required
                   placeholder="Надо будет подтвердить"/>
            {email === '' && textError}

            <label className="auth-label clr-white fs-14 mt-8">Придумайте пароль{sign}:</label>
            <input autoComplete='off' name='pass' className={`auth-input big ${pass === '' ? 'error' : ''}`}
                   type="password" onChange={(e) => setPass(e.target.value)} required placeholder="Сложный"/>
            {pass === '' && textError}

            <label className="auth-label clr-white fs-14 mt-8">Наименование юридического
                лица{!isSpecLPO && sign}:</label>
            <input autoComplete='off' name='company' className={`auth-input big ${company === '' ? 'error' : ''}`}
                   type="text" onChange={(e) => setCompany(e.target.value)} required={!isSpecLPO ? true : false}
                   placeholder={`Включая "ООО" и т.п.`}/>
            {company === '' && !isSpecLPO && textError}

            <label className="auth-label clr-white fs-14 mt-8">ИНН{!isSpecLPO && sign}:</label>
            <input autoComplete='off' name='inn' className={`auth-input big ${inn === '' && !isSpecLPO ? 'error' : ''}`}
                   type="text" onChange={(e) => setInn(e.target.value)} required={!isSpecLPO ? true : false}
                   placeholder="Только цифры"/>
            {inn === '' && !isSpecLPO && textError}

            <label className="auth-label clr-white fs-14 mt-8">Контактный телефон:</label>
            <input autoComplete='off' name='phone' className="auth-input big" type="text"
                   onChange={(e) => setPhone(e.target.value)} placeholder="Не будет виден другим"/>

            <div style={{ marginTop: "4px" }}>
                <input onChange={e => setIsAccessLPO(e.currentTarget.checked)} className="custom-checkbox"
                       type="checkbox" id="accessLPO" checked={isAccessLPO}/>
                <label className="auth-label clr-white fs-14 mt-8" htmlFor="accessLPO">Доступен интерфейс работы с актами ЛПО</label>
            </div>

            <label className="auth-label clr-white fs-14 mt-8">Получать уведомления:</label>
            <input onChange={e => setCheckRequests(e.currentTarget.checked)} className="custom-checkbox" type="checkbox"
                   id="new-requests" checked={isCheckRequests}/>
            <label for="new-requests">О новых запросах</label>
            <input onChange={e => setCheckComments(e.currentTarget.checked)} className="custom-checkbox" type="checkbox"
                   id="new-comments" checked={isCheckComments}/>
            <label for="new-comments">О новых комментариях</label>

            <div style={{ marginTop: "12px" }}>
                <input onChange={e => setIsPoliticsAccepted(e.currentTarget.checked)} className="custom-checkbox"
                       type="checkbox" id="politicsAccepted" checked={isPoliticsAccepted}/>
                <label 
                    className="auth-label clr-white fs-14 mt-8 multiline-label" 
                    htmlFor="politicsAccepted" 
                    style={{display: 'inline'}}
                >
                    Я принимаю{' '}
                    <a 
                        href='https://naturepeople.ru/policy/' 
                        target='_blank' 
                        rel='noopener noreferrer' 
                        onClick={e => e.stopPropagation()} 
                        style={{display: 'inline'}}
                    >
                        условия политики в отношении обработки персональных данных
                    </a>
                    {sign}
                </label>
            </div>

            <p className="auth-label-required mt-4">*Эти поля обязательны</p>

            <div style={{marginTop: '8px'}} className='auth-loginForm links'>
                <span onClick={() => openPopup('Авторизация', <UserLogin/>)}>Авторизация</span>
            </div>


            <div style={{display: 'flex', justifyContent: 'center'}}>
                <button 
                    className="auth-button mt-24" 
                    type="submit" 
                >
                    Зарегистрироваться
                </button>
            </div>
        </form>
    )

    function register(e) {
        e.preventDefault()
        email = email && email.toLowerCase()
        new Promise((resolve) => {
            if (!isSpecLPO && username && pass && email && inn && company && isPoliticsAccepted) resolve()
            else if (isSpecLPO && username && pass && email && isPoliticsAccepted) resolve()
            else throw new Error("Необходимо заполнить все обязательные поля")
        }).then(() => {
            if (/^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/.test(email)) return true
            else throw new Error("Неверный формат электронной почты")
        }).then(() => {
            if (username.length <= 100) return true
            else throw new Error("Никнейм должен содержать не более 100 символов")
        }).then(() => {
            if (!inn && isSpecLPO) return true
            else if (inn.length <= 12 && inn.length >= 10 && /^[0-9]+$/.test(inn)) return true
            else throw new Error("ИНН должен содержать только цифры, от 10 до 12 символов")
        }).then(() => {
            if (!phone || (phone.length <= 12 && /^((8|\+7)[- ]?)?(\(?\d{3}\)?[- ]?)?[\d\- ]{7,10}$/.test(phone))) return true
            else throw new Error("Неверный формат номера телефона")
        }).then(() => {
            const data = {
                login: username,
                password: pass,
                email: email,
                inn: inn || '',
                phone: phone,
                company: company || '',
                role: role,
                chkReq: isCheckRequests,
                chkComm: isCheckComments,
                accessLPO: isAccessLPO
            }
            createUser(data)
        }).catch(error => openSnackbar(error.message, "error"))
    }
}

export default connect(null, {createUser, openSnackbar, openPopup})(UserRegister)